import { INITIALIZE, SET_LAST_STEP, SET_SELECTED_SUBJECT, SET_SELECTED_GRADE, SET_CHILD_SCREEN_NAME, SET_BACK_BUTTON_LOADING, SET_BACK_BUTTON_NOT_LOADING,
  SET_ONBOARDING_QUESTIONS_OUTCOME_DATA, SET_SKIP_PERSONALISED, SET_SV_ONBOARDING_EVENT_PARAMS, RESET_SV_ONBOARDING_EVENT_PARAMS, SET_QUESTION_RESPONSE_DATA, SET_MENTOR_INFO } from './actionTypes';

const initialState = (data) => {
  if (data.locale) {
    i18n.changeLanguage(data.locale);
    localStorage.setItem('user_preferred_language', data.locale);
  }
  return {
    storeLoaded: data.storeLoaded || false,
    onboardingStepSequence: data.onboardingStepSequence || [],
    gradeIdMap: data.gradeIdMap || {},
    gradeCodeMap: data.gradeCodeMap || {},
    subjectIdMap: data.subjectIdMap || {},
    subjectGradeMap: data.subjectGradeMap || {},
    childScreenName: data.childName || '',
    selectedGrade: data.selectedGrade || '',
    selectedSubject: data.selectedSubject || '',
    isBackButtonLoading: false,
    onboardingQuestionOutcomeMath: data.onboardingQuestionOutcomeMath || [],
    onboardingQuestionOutcomeReading: data.onboardingQuestionOutcomeReading || [],
    skipPersonalizedToggle: false,
    svOnboardingEventParams: {},
    subjectCodeMap: data.subjectCodeMap || {},
    skipPOQ: data.skipPOQ || false,
    skipSubject: data.skipSubject || false,
    userIntentionOptionSelected: data.userIntentionOptionSelected || null,
    skipForkScreen: data.skipForkScreen,
    onboardingResponseMath: data.onboardingResponseMath || [],
    onboardingResponseReading: data.onboardingResponseReading || [],
    isLPABTest: data.isLPABTest,
    mentorInfo: null
  }
};

export const onboardingReducer = (state = {}, action) => {
  switch (action.type) {
    case INITIALIZE:
      return initialState(action.payload);
    case SET_LAST_STEP:
      return { ...state, onboardingStepSequence: action.payload };
    case SET_SELECTED_SUBJECT:
      return { ...state, selectedSubject: action.payload };
    case SET_SELECTED_GRADE:
      return { ...state, selectedGrade: action.payload };
    case SET_CHILD_SCREEN_NAME:
      return { ...state, childScreenName: action.payload};
    case SET_BACK_BUTTON_LOADING:
      return { ...state, isBackButtonLoading: true};
    case SET_BACK_BUTTON_NOT_LOADING:
      return { ...state, isBackButtonLoading: false};
    case SET_SKIP_PERSONALISED:
      return { ...state, skipPersonalizedToggle: action.payload};
    case SET_SV_ONBOARDING_EVENT_PARAMS:
      return { ...state, svOnboardingEventParams: action.payload};
    case RESET_SV_ONBOARDING_EVENT_PARAMS:
      return { ...state, svOnboardingEventParams: {}}
    case SET_ONBOARDING_QUESTIONS_OUTCOME_DATA: {
      let key = '';
      if (action.payload.subject === 'math') {
        key = 'onboardingQuestionOutcomeMath';
      } else {
        key = 'onboardingQuestionOutcomeReading';
      }
      return {
        ...state, [key]: action.payload.data
      };
    }
    case SET_QUESTION_RESPONSE_DATA: {
      let key = '';
      if (action.payload.subject === 'math') {
        key = 'onboardingResponseMath';
      } else {
        key = 'onboardingResponseReading';
      }
      return {
        ...state, [key]: action.payload.data
      };
    }

    case SET_MENTOR_INFO:
      return {...state, mentorInfo: action.payload.data}

    default:
      return state;
  }
};